import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { content } from '../data/content';
import { Menu, X } from 'lucide-react';
import Button from './Button';
import logo from '../assets/Keel_logo.png'


const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setIsMenuOpen(false); // Close menu on route change
  }, [location]);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white/90 backdrop-blur-md shadow-sm py-3' : 'bg-transparent py-5'
      }`}
    >
      <div className="container-custom flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2 group cursor-pointer">
          <div className="w-14 h-14 flex items-center justify-center transform ">
            <span className="text-white font-bold text-xl"><img src={logo}/></span>
          </div>
          <span className="text-navy font-bold text-2xl tracking-tight hidden sm:block">
            {content.navbar.logo}
          </span>
        </Link>

        {/* Desktop Links */}
        <div className="hidden lg:flex items-center gap-8">
          {content.navbar.links.map((link) => {
            const isActive = location.pathname === link.href;
            return (
              <Link 
                key={link.label}
                to={link.href}
                className={`text-sm font-semibold transition-colors ${
                  isActive ? 'text-primary' : 'text-navy/70 hover:text-primary'
                }`}
              >
                {link.label}
              </Link>
            );
          })}
        </div>

        {/* CTA Button */}
        <div className="hidden md:block">
          <Link to="/contact">
            <Button variant="primary" className="px-8">
              {content.navbar.cta}
            </Button>
          </Link>
        </div>

        {/* Mobile Toggle */}
        <button 
          className="lg:hidden p-2 text-navy"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          {isMenuOpen ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="lg:hidden absolute top-full left-0 right-0 bg-white border-t border-navy/5 shadow-2xl p-6 animate-in slide-in-from-top duration-300">
          <div className="flex flex-col gap-4">
            {content.navbar.links.map((link) => {
              const isActive = location.pathname === link.href;
              return (
                <Link 
                  key={link.label}
                  to={link.href}
                  className={`text-lg font-semibold py-2 border-b border-navy/5 ${
                    isActive ? 'text-primary' : 'text-navy'
                  }`}
                  onClick={() => setIsMenuOpen(false)}
                >
                  {link.label}
                </Link>
              );
            })}
            <Link to="/contact" className="w-full mt-4 block" onClick={() => setIsMenuOpen(false)}>
              <Button variant="primary" className="w-full">
                {content.navbar.cta}
              </Button>
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
